export default __webpack_public_path__ + "static/media/image1355.8f97453f.png";